(() => {
  'use strict';
  if (window.StepzoneSlider) { window.StepzoneSlider.refresh(); return; }
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const slides = [...root.querySelectorAll('[data-lx-slide]')];
    if (slides.length < 2) return;
    const controls = root.querySelector('.lx-slider-controls');
    const dots = [...root.querySelectorAll('[data-lx-dot]')];
    const pause = root.querySelector('[data-lx-pause]');
    const status = root.querySelector('[data-lx-status]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const interval = Math.max(5000, Math.min(10000, Number(root.dataset.interval) * 1000 || 7000));
    let index = 0, timer, visible = true, focused = false;
    let paused = /^(false|0|off)$/i.test(root.dataset.autoplay || 'true');
    const stop = () => { clearTimeout(timer); timer = undefined; };
    function schedule() {
      stop();
      if (!paused && !motion.matches && visible && !focused && !document.hidden) {
        timer = setTimeout(() => show(index + 1), interval);
      }
    }
    function show(next, announce = false) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        dots[i].setAttribute('aria-pressed', String(active));
      });
      if (announce) status.textContent = `Slide ${index + 1} of ${slides.length}`;
      schedule();
    }
    pause.textContent = paused ? '▶' : 'Ⅱ';
    pause.setAttribute('aria-label', paused ? 'Resume automatic slides' : 'Pause automatic slides');
    controls.hidden = false;
    root.classList.add('lx-slider-ready');
    root.querySelector('[data-lx-prev]').addEventListener('click', () => show(index - 1, true), options);
    root.querySelector('[data-lx-next]').addEventListener('click', () => show(index + 1, true), options);
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i, true), options));
    pause.addEventListener('click', () => {
      paused = !paused;
      pause.textContent = paused ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label', paused ? 'Resume automatic slides' : 'Pause automatic slides');
      schedule();
    }, options);
    const updateMotion = () => { pause.hidden = motion.matches; schedule(); };
    motion.addEventListener('change', updateMotion, options);
    root.addEventListener('focusin', event => { focused = event.target.matches(':focus-visible'); schedule(); }, options);
    root.addEventListener('focusout', event => { focused = root.contains(event.relatedTarget) && !!event.relatedTarget?.matches(':focus-visible'); schedule(); }, options);
    root.addEventListener('keydown', event => {
      if (event.target.closest('a,input,select,textarea')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }
    }, options);
    document.addEventListener('visibilitychange', schedule, options);
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; schedule(); }, { threshold: 0.05 }) : null;
    observer?.observe(root);
    instances.set(root, () => { stop(); observer?.disconnect(); controller.abort(); });
    updateMotion(); show(0);
  }
  function refresh(scope = document) {
    if (scope.matches?.('[data-lx-slider]')) init(scope);
    scope.querySelectorAll('[data-lx-slider]').forEach(init);
  }
  window.StepzoneSlider = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) if (event.target.contains(root)) { destroy(); instances.delete(root); }
  });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-lx-slide]');
    if (!slide) return;
    const root = slide.closest('[data-lx-slider]');
    const index = [...root.querySelectorAll('[data-lx-slide]')].indexOf(slide);
    root.querySelector(`[data-lx-dot="${index}"]`)?.click();
    const pause = root.querySelector('[data-lx-pause]');
    if (pause?.getAttribute('aria-label') === 'Pause automatic slides') pause.click();
  });
})();
